@if (fullName(); as fullName) {
  <mat-card class="bottom-card">
    <div class="card-container">
      <mat-card-header [style.margin-left]="!showAvatar() ? (AVATAR_WIDTH + 16).toString() + 'px' : null">
        <div matCardAvatar>
          <glxy-avatar
            [width]="AVATAR_WIDTH"
            icon="{{ activityIcon() }}"
            shape="square"
            backgroundColor="var(--primary-background-color)"
            textColor="var(--tertiary-text-color)"
          ></glxy-avatar>
        </div>
      </mat-card-header>
      <mat-card-content class="content-container">
        <mat-card appearance="outlined" class="inner-card">
          <mat-card-header class="card-header">
            <mat-card-title>
              <span class="title">
                <ng-container *ngTemplateOutlet="header"></ng-container>
                @if (showPrimaryAssociation()) {
                  @if (primaryAssociation(); as primaryAssociation) {
                    {{ 'OBJECT_TYPES.FOR_LABEL' | translate }}
                    <a [routerLink]="routePrefix() + '/' + primaryAssociation.linkUrl">{{ primaryAssociation.name }}</a>
                  }
                }
              </span>
            </mat-card-title>
            <div class="effective-date-and-options">
              <mat-card-subtitle>
                @if (subtitleTemplate) {
                  <ng-container *ngTemplateOutlet="subtitleCustomTemplate"></ng-container>
                } @else {
                  <ng-container *ngTemplateOutlet="subtitleDefaultTemplate"></ng-container>
                }
              </mat-card-subtitle>
              <div class="options-menu">
                <ng-content select="[crmActivityTemplateOptions]"></ng-content>
              </div>
            </div>
          </mat-card-header>
          <mat-card-content>
            <ng-content></ng-content>
          </mat-card-content>
        </mat-card>
      </mat-card-content>
    </div>
  </mat-card>
}

<ng-template #header>
  @if (headerText(); as headerText) {
    @if (headerText.typeWithVerb) {
      <strong>{{ headerText.typeWithVerb | translate }}</strong>
    }
    @if (headerText.preposition) {
      {{ headerText.preposition | translate }}
    }
    @if (fullName(); as fullName) {
      {{ fullName }}
    }
  } @else {
    {{ 'ACTIVITY.UNKNOWN_TITLE' | translate }}
  }
</ng-template>

<ng-template #subtitleDefaultTemplate>
  @if (effectiveDate(); as effectiveDate) {
    <p class="effective-date">
      {{ effectiveDate | date: dateFormat }}
    </p>
  }
</ng-template>

<ng-template #subtitleCustomTemplate>
  <div class="effective-date">
    <ng-container *ngTemplateOutlet="subtitleTemplate!"></ng-container>
  </div>
</ng-template>
